/* Frost Away: posuvník před/po v sekci fs-ba (gr.js obsluhuje jen .gr-ba uvnitř PDP). */
(function () {
  if (window.__fsInit) return;
  window.__fsInit = true;
  const boot = () => document.querySelectorAll('[data-fs-ba]').forEach((ba) => {
    const set = (x) => {
      const r = ba.getBoundingClientRect(), pct = Math.min(100, Math.max(0, (x - r.left) / r.width * 100));
      ba.style.setProperty('--x', pct + '%');
      ba.classList.toggle('is-hide-b', pct < 22);
      ba.classList.toggle('is-hide-a', pct > 78);
    };
    let drag = false;
    ba.addEventListener('pointerdown', (e) => { drag = true; ba.setPointerCapture(e.pointerId); set(e.clientX); });
    ba.addEventListener('pointermove', (e) => { if (drag) set(e.clientX); });
    ba.addEventListener('pointerup', () => { drag = false; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
